export const getShareLinkFn = (needOriginUrl?) => {
    const originUrl = window.clientVars.shortLink || window.location.href.split('#')[0];
    if (needOriginUrl) return originUrl;
    if (originUrl.indexOf('?') === -1) {
        // originUrl += '?_wv=131072';
        return originUrl;
    }
    const para = originUrl.split('?')[1];
    const newUrl = originUrl.split('?')[0];
    if (!para) {
        return originUrl;
    }
    return newUrl;
};
